import React from "react";

import { Modal } from "@mui/material";
import classNames from "classnames";

import useStyles from "./styles";

const ShipeeziIcon = require("Assets/img/appLogo.png");

interface LoadingScreenProps {
  showing: boolean;
  message: string;
}

const LoadingScreen = ({ showing, message }: LoadingScreenProps) => {
  const classes = useStyles();

  return (
    <Modal open={showing} data-cy="switchCompanyLoadingScreen">
      <div className={classes.loadingScreenContainer}>
        <div className={classes.imageLogoContainer}>
          <img
            src={ShipeeziIcon}
            alt="session-logo"
            className={classNames("img-fluid", classes.shipeeziLogo)}
          />
        </div>

        <div className={classes.logoShadow} />

        <span className={classes.loadingText}>{message}</span>
      </div>
    </Modal>
  );
};

export default LoadingScreen;
